export default __webpack_public_path__ + "static/media/ic_wallet_24.a19a6758.svg";